var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "left icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom-lists---Tickets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/6.-Icon-only/1.-Default-Copy",
    transform: "translate(-15.000000, -14.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-action-/-refresh",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.441942, 15.075825) rotate(45.000000) translate(-15.441942, -15.075825) translate(6.691942, 1.950825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.89175,6.15076135 C14.2574753,6.41699625 14.6072277,6.71509201 14.9371843,7.04504865 C18.3542719,10.4621362 18.3542719,16.0023298 14.9371843,19.4194173 C13.2285013,21.1281004 10.9889552,21.982233 8.74945235,21.982233 M3.41027209,20.1652498 C3.11593329,19.9379626 2.83275009,19.6893517 2.56281566,19.4194173 C-0.854271889,16.0023298 -0.854271889,10.4621362 2.56281566,7.04504865 C3.71889778,5.88896653 5.11799699,5.12401454 6.59567635,4.75019266 C7.30147789,4.57163968 8.02520684,4.48223305 8.7489445,4.48223305",
    id: "Shape",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeWidth: 1.5,
    transform: "translate(6.536567, 4.500855) rotate(45.000000) translate(-6.536567, -4.500855) ",
    points: "3.72406701 1.75566223 9.34906701 1.68835454 9.28175932 7.31335454"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeWidth: 1.5,
    transform: "translate(10.955984, 22.001747) scale(-1, 1) rotate(45.000000) translate(-10.955984, -22.001747) ",
    points: "8.14348439 19.2565551 13.7684844 19.1892474 13.7011767 24.8142474"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.74945235,
    y1: 21.982233,
    x2: 6.97850875,
    y2: 22.0017474,
    id: "Path-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.7489445,
    y1: 4.48223305,
    x2: 10.5140427,
    y2: 4.50085454,
    id: "Path-3",
    strokeLinecap: "square"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.2260a72f.svg";
export { ForwardRef as ReactComponent };